<template>
  <div>
    <custom-page-table
      ref="table2"
      rowKey="id"
      :columns=" columns"
      :requestPromise="loadPromise"
    >
      <!--    <span slot="capitalFlows" slot-scope="rowItem">-->
      <!--      {{rowItem.text|capitalFlowsTypeName}}-->
      <!--    </span>-->
      <!--    <span slot="category" slot-scope="rowItem">-->
      <!--&lt;!&ndash;      <span v-if="rowItem.record.capitalFlows ==1">{{rowItem.text|incomeCategoryTypeName}}</span>&ndash;&gt;-->
      <!--&lt;!&ndash;      <span v-else>{{rowItem.text|expendCategoryTypeName}}</span>&ndash;&gt;-->
      <!--        {{rowItem.text|incomeExpendTypeName}}-->
      <!--    </span>-->
    </custom-page-table>
  </div>
</template>

<script>
export default {
  name: 'IncomeComponent',
  data() {
    return {
      statementId: '',
      loadPromise: params => this.getAccountData(params),
      columns: [
        {
          title: '入账时间',
          dataIndex: 'creditTime'
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo'
        },
        {
          title: '资金流向',
          dataIndex: 'capitalFlowsName'
        },
        {
          title: '收支类别',
          dataIndex: 'categoryName'
        },
        {
          title: '收支金额(元)',
          dataIndex: 'amount'
        }
      ]
    }
  },
  methods: {
    getAccountData(params) {
      this.statementId = this.$route.query.statementId
      return this.getHttpServices().getUserService().post('api/v2/financialTransactionr/billingIncomeExpenditureDetails', {
        limitDto: params,
        statementId: this.statementId
      })
    }
  }
}
</script>
<style scoped>
</style>
